import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/Directive.vue
 */
export default function checkPermission (value) {
  if (value && value instanceof Array && value.length > 0) {
    const role = store.getters && store.getters['auth/profile']
    return value.includes(role.role)
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js